import React from 'react';
import { Box } from '@mui/material';
import { ResultCard } from '@features/proposals/ScopeSelector/ResultCard';
import { PhasesCard } from '@features/proposals/ScopeSelector/PhasesCard';
import { BUILD_HEADER_STICKY_REPLACE_ATTR } from '@features/proposals/ElementListRow/use-build-header-sticky-replace.hook';

export const BUILD_VIEW_HEADER_HEIGHT = 46;

export const BuildViewHeader: React.FC = () => {
  return (
    <Box
      component="header"
      aria-label="Build"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: BUILD_VIEW_HEADER_HEIGHT,
        boxSizing: 'border-box',
        position: 'sticky',
        top: 0,
        // The list/focus header uses the next layer and replaces this header
        // once it reaches the top of the shared Build scrollport.
        zIndex: 3,
        minWidth: 0,
        flexShrink: 0,
        [`[${BUILD_HEADER_STICKY_REPLACE_ATTR}] &`]: {
          visibility: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          ml: '16px',
          mr: '8px',
        }}
      >
        <PhasesCard panelAlignment="left" portal />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }} />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          mx: '8px',
        }}
      >
        <ResultCard />
      </Box>
    </Box>
  );
};
